import { ReactComponent as ArrowBack } from './arrowBack.svg';

export default ArrowBack;
